<template>
  <div>
    <el-alert
      title="1 个源单位 = 系数 × 目标单位。没有正向关系时，试算会用反向关系的倒数。"
      type="info" :closable="false" show-icon style="margin-bottom:12px"
    />
    <div class="toolbar">
      <el-select v-model="query.unitFrom" clearable filterable placeholder="源单位" style="width:160px">
        <el-option v-for="u in units" :key="u.id" :label="u.dictLabel" :value="String(u.id)" />
      </el-select>
      <el-select v-model="query.unitTo" clearable filterable placeholder="目标单位" style="width:160px">
        <el-option v-for="u in units" :key="'q'+u.id" :label="u.dictLabel" :value="String(u.id)" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button @click="openConvert">试算</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
    </div>
    <el-table :data="list" border v-loading="loading">
      <el-table-column prop="unitFromName" label="源单位" min-width="140" />
      <el-table-column prop="unitToName" label="目标单位" min-width="140" />
      <el-table-column prop="factor" label="系数(1源=系数目标)" width="180" align="right" />
      <el-table-column label="启用" width="80" align="center">
        <template slot-scope="{ row }">
          <el-tag size="small" :type="row.active === '1' ? 'success' : 'info'">{{ row.active === '1' ? '是' : '否' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" min-width="140" show-overflow-tooltip />
      <el-table-column label="操作" width="140" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openEdit(row.conversionId)">修改</el-button>
          <el-button type="text" style="color:#ef4444" @click="onDelete(row.conversionId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination :total="total" :page="page" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]" @current-change="onPage" @size-change="onSize" />

    <el-dialog :title="form.conversionId ? '修改单位换算' : '新增单位换算'" :visible.sync="visible" width="480px" :close-on-click-modal="false">
      <el-form :model="form" label-width="100px">
        <el-form-item label="源单位">
          <el-select v-model="form.unitFrom" filterable style="width:100%">
            <el-option v-for="u in units" :key="u.id" :label="unitLabel(u)" :value="String(u.id)" />
          </el-select>
        </el-form-item>
        <el-form-item label="目标单位">
          <el-select v-model="form.unitTo" filterable style="width:100%">
            <el-option v-for="u in units" :key="'t'+u.id" :label="unitLabel(u)" :value="String(u.id)" />
          </el-select>
        </el-form-item>
        <el-form-item label="换算系数">
          <el-input-number v-model="form.factor" :min="0.000001" :precision="6" style="width:100%" />
          <div style="color:#999;font-size:12px;margin-top:4px">含义：1 源单位 = 系数 × 目标单位</div>
        </el-form-item>
        <el-form-item label="启用"><el-switch v-model="form.active" active-value="1" inactive-value="0" /></el-form-item>
        <el-form-item label="备注"><el-input v-model="form.remark" type="textarea" :rows="2" /></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submit">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog title="单位换算试算" :visible.sync="convertVisible" width="480px" :close-on-click-modal="false">
      <el-form label-width="90px">
        <el-form-item label="源单位">
          <el-select v-model="convertForm.unitFrom" filterable style="width:100%">
            <el-option v-for="u in units" :key="'cf'+u.id" :label="u.dictLabel" :value="String(u.id)" />
          </el-select>
        </el-form-item>
        <el-form-item label="目标单位">
          <el-select v-model="convertForm.unitTo" filterable style="width:100%">
            <el-option v-for="u in units" :key="'ct'+u.id" :label="u.dictLabel" :value="String(u.id)" />
          </el-select>
        </el-form-item>
        <el-form-item label="数量"><el-input-number v-model="convertForm.quantity" :min="0" :precision="6" style="width:100%" /></el-form-item>
        <el-form-item v-if="convertResult != null" label="结果">
          <b>{{ convertResult }}</b>
          <span v-if="convertMeta" style="color:#999;margin-left:8px">（{{ convertMeta }}）</span>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="convertVisible = false">关闭</el-button>
        <el-button type="primary" @click="runConvert">换算</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import { listUnitConversion, getUnitConversion, saveUnitConversion, updateUnitConversion, deleteUnitConversion, convertUnit } from '../../api/unitConversion'
import { listDictOptions } from '../../api/dict'

function emptyForm() {
  return { conversionId: '', unitFrom: '', unitTo: '', factor: 1, active: '1', remark: '' }
}

export default {
  components: { ListPagination },
  data() {
    return {
      query: { unitFrom: '', unitTo: '' },
      list: [], total: 0, page: 1, pageSize: 20, loading: false,
      units: [], visible: false, saving: false, form: emptyForm(),
      convertVisible: false, convertForm: { unitFrom: '', unitTo: '', quantity: 1 },
      convertResult: null, convertMeta: ''
    }
  },
  created() {
    listDictOptions('UNIT').then(res => { this.units = res.data || [] }).catch(() => {})
    this.load()
  },
  methods: {
    unitLabel(u) {
      return u.dictValue ? (u.dictLabel + ' / ' + u.dictValue) : u.dictLabel
    },
    load() {
      this.loading = true
      listUnitConversion({ ...this.query, currentPage: this.page, pageSize: this.pageSize }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    openEdit(id) {
      this.form = emptyForm()
      this.visible = true
      if (!id) return
      getUnitConversion(id).then(res => { this.form = Object.assign(emptyForm(), res.data || {}) })
    },
    submit() {
      if (!this.form.unitFrom || !this.form.unitTo) { this.$message.warning('请选择源/目标单位'); return }
      if (!this.form.factor || this.form.factor <= 0) { this.$message.warning('系数须大于0'); return }
      this.saving = true
      const req = this.form.conversionId ? updateUnitConversion(this.form) : saveUnitConversion(this.form)
      req.then(() => {
        this.$message.success('保存成功')
        this.visible = false
        this.load()
      }).finally(() => { this.saving = false })
    },
    onDelete(id) {
      this.$confirm('确定删除?', '提示', { type: 'warning' }).then(() => {
        deleteUnitConversion([id]).then(() => { this.$message.success('已删除'); this.load() })
      }).catch(() => {})
    },
    openConvert() {
      this.convertForm = { unitFrom: '', unitTo: '', quantity: 1 }
      this.convertResult = null
      this.convertMeta = ''
      this.convertVisible = true
    },
    runConvert() {
      if (!this.convertForm.unitFrom || !this.convertForm.unitTo) { this.$message.warning('请选择单位'); return }
      convertUnit(this.convertForm).then(res => {
        const body = res.data || {}
        this.convertResult = body.result
        this.convertMeta = '方向=' + body.direction + '，因子=' + body.factor
      })
    }
  }
}
</script>
